import { useState } from "react";
import {
  UpdateCommentRequest,
  useVbsTreatmentUpdateCommentMutation,
} from "@/services/backend/vbs/treatments/api/treatment-api";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import { Textarea } from "@/shared/components/ui/textarea";

export function CommentCell(props: {
  treatmentId: string;
  positionId: string;
  comment: string;
  disabled?: boolean;
}) {
  const { treatmentId, positionId, comment, disabled = false } = props;
  const [request, setRequest] = useState<UpdateCommentRequest>({
    id: treatmentId,
    positionId,
    comment,
  });
  const mutation = useVbsTreatmentUpdateCommentMutation();

  useDebouncedMutation(request, setRequest, mutation, {
    id: treatmentId,
    positionId,
    comment,
  });

  return (
    <Textarea
      className="block min-h-0 w-full px-2 py-0.5 text-sm"
      rows={3}
      value={request.comment}
      onChange={(e) => setRequest({ ...request, comment: e.target.value })}
      disabled={disabled}
    />
  );
}
